import EditarPedido from "../components/EditarPedido"

export default function EditarPedidoPage(){
    return(
        <div className='bg-slate-300'>

            <EditarPedido />
        </div>
    )
}